import { render, staticRenderFns } from "./movingEditGoodsDialog.vue?vue&type=template&id=39bcc266&"
import script from "./movingEditGoodsDialog.vue?vue&type=script&lang=js&"
export * from "./movingEditGoodsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports